// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2VWtj","name":"Header_name__2Sr54","birthday":"Header_birthday__3zYyt","skeleton":"Header_skeleton__3yx-S"};